import { ActionTypes as action } from "./action-types";
import adminService from "../../../api/adminService";
import { currentDateTime } from "../../../utils/util";

const actions = {
    async getStatisticsData({ commit }, reqData) {
        const data = await adminService.getStatisticsData(reqData);
        commit(action.GET_STATISTICS_DATA, data);
        return data;
    },
    async getUserList({ commit }) {
        const data = await adminService.getUserList();
        commit(action.GET_USER_LIST, data);
        return;
    },
    clearUserList({ commit }) {
        commit(action.GET_USER_LIST, []);
        return;
    },
    async getRoleList({ commit }) {
        const data = await adminService.getRoleList();
        commit(action.GET_ROLE_LIST, data);
        return;
    },
    async getRoleById({ commit }, id) {
        const data = await adminService.getRoleById(id);
        commit(action.GET_ROLE_BY_ID, data);
        return data
    },
    async getUserById({ commit }, id) {
        const data = await adminService.getUserById(id);
        commit(action.GET_USER_BY_ID, data);
        return data
    },
    async getUserData({ commit }, id) {
        const data = await adminService.getUserById(id);
        return data
    },
    async getUserByEmailId({ commit }, emailid) {
        const data = await adminService.getUserByEmailId(emailid);
        return data
    },
    async createRole({ dispatch, commit }, data) {
        await adminService.createRole(data);
        return;
    },
    async createUser({ dispatch, commit }, data) {
        await adminService.createUser(data);
        return;
    },
    async updateRole({ dispatch, commit }, data) {
        const result = await adminService.updateRole(data);
        commit(action.GET_ROLE_BY_ID, result);
        return;
    },
    async updateUser({ dispatch, commit }, data) {
        const result = await adminService.updateUser(data);
        commit(action.GET_USER_BY_ID, result);
        return;
    },
    async deleteRole({ dispatch, commit }, id) {
        const result = await adminService.deleteRole(id);
        return result;
    },
    async deleteUser({ dispatch, commit }, id) {
        const data = await adminService.deleteUser(id);
        return data;
    },
    async changeUserPassword({ dispatch, commit }, data) {
        const result = await adminService.changeUserPassword(data);
        return result;
    },
    async getActivityList({ commit }, query) {
        let results = await adminService.getActivitylogList(query);
        //results.data.sort(function (a, b) { return new Date(b.calledAt) - new Date(a.calledAt); });
        const data = results.data.map((data) => {
            return {
                tenantid: data.tenantid,
                api: data.api,
                api_request_method: data.api_request_method,
                category: data.module ?? '',
                module: data.module ?? '',
                is_user_activity: data.is_user_activity,
                user: data.user_name ?? '',
                user_email: data.user_email ?? '',
                parameters: data.parameters,
                status: data.status ? data.status.charAt(0).toUpperCase() + data.status.slice(1).toLowerCase() : '',
                status_code: data.status_code,
                message: data.message,
                error_message: data.error_message,
                time: currentDateTime(data.calledAt),
                activity: data.message ?? '',
                api_key: data.api_key,
                platform: data.platform,
                version: data.version,
                user_agent: data.user_agent
            };
        })
        commit(action.GET_ACTIVITY_LIST, data);
        commit(action.GET_TOTAL_ACTIVITY_COUNT, results.total_count);
        return;
    },
    resetActivityLogs({ commit }) {
        let data = [];
        commit(action.RESET_ACTIVITY_LIST, data);
        return;
    },
    setActivityFilter({ commit }, formData) {
        commit(action.SET_ACTIVITY_FILTER, formData);
    },
    resetState({ commit }) {
        commit(action.RESET_STATE);
    },
    async getTopicFeedbacks({ }, filterPrams) {
        const result = await adminService.getTopicFeedbacks(filterPrams);
        return result;
    },
    async updateTenantGrouping({ }, data) {
        const result = await adminService.updateTenantGrouping(data);
        return result;
    },
    setTenantGroupData({ commit }, data) {
        commit(action.SET_TENANT_GROUP_DATA, data);
    }

};
export default actions;
